<template>  
  <bm-overlay
    ref="overlay"
    class="sample"
    pane="labelPane"
    @draw="draw"
    @mouseover.native="$refs.input.focus()"
    @mouseleave.native="$refs.input.blur()">
    <el-tabs v-model="activeName" @click.native.stop="()=>{}">
      <el-tab-pane :label="$t('location.walking')" name="walking"></el-tab-pane>
      <el-tab-pane :label="$t('location.driving')" name="driving"></el-tab-pane>
      <el-tab-pane :label="$t('location.transit')" name="transit"></el-tab-pane>
      <el-input style="margin-bottom:5px" ref="input" v-model="mapObj.routeName" :placeholder="$t('location.routeName')"/>
      <div v-if="!noneNav">        
        <p>{{formateMile(distance)}}</p>
        <p>{{formateSeconds(duration)}}</p>
      </div>
      <div v-else>{{$t('location.noTransit')}}</div>
    </el-tabs>
    <!-- 步行导航 -->
    <bm-walking 
      v-if="activeName==='walking'"
      :start="startPoint" 
      :end="endPoint" 
      :auto-viewport="false"
      :panel="false"
      @searchcomplete="searchcomplete">
    </bm-walking>
    <!-- 驾车导航 -->
    <bm-driving
      v-if="activeName==='driving'"
      :start="startPoint" 
      :end="endPoint" 
      :auto-viewport="false"
      :panel="false"
      @searchcomplete="searchcomplete">
    </bm-driving>
    <!-- 公交导航 -->
    <bm-transit 
      v-if="activeName==='transit'"
      :start="startPoint" 
      :end="endPoint" 
      :auto-viewport="false"
      :panel="false"
      selectFirstResult
      @searchcomplete="searchcomplete">
    </bm-transit>
  </bm-overlay>   
</template>
<script>
import {BmOverlay, BmWalking, BmDriving, BmTransit } from 'vue-baidu-map'
export default {
  name: 'Overlay',
  components: { BmOverlay, BmWalking, BmDriving, BmTransit },
  props: {
    startPoint:{},
    endPoint:{},
    mapObj:{
      routeName:''
    }
  },
  watch: {
    endPoint: {
      handler () {
        this.$refs.overlay.reload()
      },
      deep: true
    }
  },
  data() {
    return {
      activeName: 'walking',
      distance: 0,
      duration: 0,
      noneNav: false,
    }
  },
  methods: {
    handleInputClick() {
      console.log(1)
    },
    // 规划路线
    searchcomplete(results) {
      let data = undefined
      Object.keys(results).forEach(r=>{
        if(results[r] instanceof Array) {
          data = results[r]
        }        
      })
      if (data[0]) {
        this.noneNav = false
        Object.keys(data[0]).forEach((d, index)=>{
          if(index===1) {
            this.distance = data[0][d]
          } else if (index===2) {
            this.duration = data[0][d]
          }
        })    
      } else {
        this.noneNav = true
        this.distance = 0
        this.duration = 0
      }    
      this.$emit('handleNav',this.distance,this.duration,this.activeName)
    },
    formateMile(mile) {
      let result = mile / 1000
      if(result > 1){
        return result.toFixed(1)+ this.$t('location.km')
      }else{
        return mile + this.$t('location.m')
      }
    },
    formateSeconds(endTime){
      let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
      let min = 0// 初始化分
      let h =0// 初始化小时
      let result=''
      if(secondTime>60){//如果秒数大于60，将秒数转换成整数
        min=parseInt(secondTime/60)//获取分钟，除以60取整数，得到整数分钟
        secondTime=parseInt(secondTime%60)//获取秒数，秒数取佘，得到整数秒数
        if(min>60){//如果分钟大于60，将分钟转换成小时
          h=parseInt(min/60)//获取小时，获取分钟除以60，得到整数小时
          min=parseInt(min%60) //获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result= h===0 ? min+1 +this.$t('location.minutes'): `${h}${this.$t('location.hour')}${min+1}${this.$t('location.minutes')}`
      return result 
    },
    draw ({el, BMap, map}) {
      const pixel = map.pointToOverlayPixel(this.endPoint)
      el.style.left = pixel.x + 40 + 'px'
      el.style.top = pixel.y - 60 + 'px'
    }
  }
}
</script>
<style>
.sample {
  background: #fff;
  text-align: center;
  position: absolute;
}
.sample .el-tabs {
  padding: 10px 20px;
}
</style>